import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Building2 } from "lucide-react";

export default function MentionsLegales() {
  const [s, setS] = useState({});
  useEffect(() => { api.get("/site-settings").then((r) => setS(r.data || {})).catch(()=>{}); }, []);

  return (
    <div className="max-w-3xl mx-auto px-4 py-14" data-testid="page-mentions-legales">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 rounded-xl bg-orange-50 text-[#E05638] grid place-items-center"><Building2 size={22}/></div>
        <h1 className="font-heading text-3xl md:text-4xl font-extrabold">Mentions légales</h1>
      </div>
      <div className="bg-white border border-slate-200 rounded-2xl p-6 md:p-8 space-y-6 text-sm text-slate-700 leading-relaxed">
        <section>
          <h2 className="font-heading text-lg font-bold text-slate-900">Éditeur du site</h2>
          <p className="mt-2">
            {s.legal_company || "PROXIreduc-28"}<br/>
            {s.legal_publisher ? <>Directeur de la publication : {s.legal_publisher}<br/></> : null}
            {s.legal_siret ? <>SIRET : {s.legal_siret}<br/></> : null}
            {s.contact_address ? <>Adresse : {s.contact_address}<br/></> : null}
            {s.contact_email ? <>Email : <a className="text-[#E05638] underline" href={`mailto:${s.contact_email}`}>{s.contact_email}</a><br/></> : null}
            {s.contact_phone ? <>Téléphone : {s.contact_phone}</> : null}
          </p>
        </section>
        <section>
          <h2 className="font-heading text-lg font-bold text-slate-900">Hébergement</h2>
          <p className="mt-2">
            Ce site est hébergé sur l'infrastructure cloud d'Emergent Labs.
          </p>
        </section>
        <section>
          <h2 className="font-heading text-lg font-bold text-slate-900">Propriété intellectuelle</h2>
          <p className="mt-2">
            L'ensemble des contenus (textes, logos, images, code) présents sur ce site est protégé
            par le droit d'auteur. Toute reproduction, même partielle, est soumise à autorisation.
          </p>
        </section>
        <section>
          <h2 className="font-heading text-lg font-bold text-slate-900">Responsabilité</h2>
          <p className="mt-2">
            PROXIreduc-28 met en relation des professionnels partenaires et des bénéficiaires. Les
            offres publiées sont sous la responsabilité de leurs auteurs. Pour signaler un abus,
            écrivez-nous à <a className="text-[#E05638] underline" href={`mailto:${s.contact_email || "info.proxireduc@gmail.com"}`}>{s.contact_email || "info.proxireduc@gmail.com"}</a>.
          </p>
        </section>
      </div>
    </div>
  );
}
